<template>
  <div>
    <pcHeaders></pcHeaders>
    <div class="namms">
      <div>
        <div class="suc">
          <div><img src="../../assets/images/pay_blue.png" alt="安全生产学习平台" /></div>
          <div style="font-size: 22px; color: #4076f6; margin-top: 22px">恭喜您，支付成功</div>
        </div>

        <div class="payDetail">
          <div class="payHead">
            <div class="su"></div>
            <div style="font-weight: bold">支付详情</div>
          </div>
          <div class="list">
            <div>订单编号</div>
            <div>{{ orderList.ordNo }}</div>
          </div>
          <!-- <div class="list">
            <div>订单金额</div>
            <div style="color: #4076f6;">¥{{ orderList.ordMoneysum }}</div>
          </div> -->
          <div class="list">
            <div>支付时间</div>
            <div>{{ orderList.ordPaytime }}</div>
          </div>
          <!-- <div class="list">
            <div>支付方式</div>
            <div>
              {{ orderList.ordPaytype =='01' ? '在线支付' :  orderList.ORD_PAYTYPE =='02' ? '学习帐户' :orderList.ORD_PAYTYPE =='03' ? '现金面付' :orderList.ORD_PAYTYPE =='04' ? '银行汇款' :orderList.ORD_PAYTYPE =='05' ? '邮局汇款' :orderList.ORD_PAYTYPE =='06' ? '支付宝'  :orderList.ORD_PAYTYPE =='07' ? '手机支付(支付宝)' :orderList.ORD_PAYTYPE =='08' ? '刷卡支付' :orderList.ORD_PAYTYPE =='00' ? '其它' :orderList.ORD_PAYTYPE =='0901' ? '微信公众号' :orderList.ORD_PAYTYPE =='0902' ? '微信WAP' :orderList.ORD_PAYTYPE =='0903' ? '微信扫码' :orderList.ORD_PAYTYPE =='0904' ? '微信APP' :orderList.ORD_PAYTYPE =='10' ? '手工' :orderList.ORD_PAYTYPE =='11' ? '银联支付' :orderList.ORD_PAYTYPE =='12' ? '手机银联' :orderList.ORD_PAYTYPE =='13' ? '未到账' :''}}
            </div>
          </div> -->
          <div class="list">
            <div>支付金额</div>
            <div style="color: #4076f6">￥{{ orderList.ordMoneysum }}</div>
          </div>
          <div class="list">
            <div>支付方式</div>
            <div>{{ orderList.ordPaytype == '02' ? '支付宝支付' : '微信支付' }}</div>
          </div>
        </div>

        <div class="btnBox">
          <div style="display: flex;">
            <div class="ordBtn" @click="goRout(1)">立即学习</div>
          <div class="ordBtn"  @click="goRout(2)" style="background: #3172F6;color: #fff;">查看订单</div>
          </div>
        </div>
      </div>
    </div>
    <pcBottom></pcBottom>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import pcHeaders from '../component/head.vue';
import pcBottom from '../component/bottom.vue';
import { toPaySuccess,healthScreenshot,healthCertificate,studentCard } from '@/api/pay.js';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    pcHeaders,
    pcBottom
  },
  data() {
    // 这里存放数据
    return {
      orderList: {},
      independentExamList: [],
      eOrderDetailList: [],
      isMember: '',
      isZypx: ''
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    goRout(type) {
      if (type == 1) {
        this.$router.push('/studyMain')
      }else {
        this.$router.push({
          path:'/studyMain',
          query:{
            tabIndex:3
          }
        })
      }
    },
    goZy() {
      this.$router.push('/resourcesList');
    },
    goStudy() {
      this.$router.push({
        path: '/studyMain',
        query: {
          tabIndex: '8'
        }
      });
    },
    getList(id) {
      toPaySuccess({ orderId: id }).then(res => {
        this.orderList = res.data.data;
        healthScreenshot({userId:this.orderList.userId,orderId:this.orderList.id}).then(res => {
          console.log(res);
        })
        healthCertificate({userId:this.orderList.userId,orderId:this.orderList.id}).then(res => {
          console.log(res);
        })
        studentCard({userId:this.orderList.userId,orderId:this.orderList.id}).then(res => {
          console.log(res);
        })
      });
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
     //支付宝的回调
    if (this.$route.query.is_success) {
      if (this.$route.query.is_success == 'T') {
        this.getList(this.$route.query.out_trade_no);
      }
    }else {
        //微信回调
        this.getList(this.$route.query.orderId);
      }
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, // 生命周期 - 创建之前
  beforeMount() {} // 生命周期 - 挂载之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.flex {
  display: flex;
}
.resources {
  position: relative;
  width: 1400px;
  height: 120px;
  padding: 30px 40px 30px 134px;
  cursor: pointer;
  .leftTop {
    position: absolute;
    top: 0;
    left: 0;
    width: 134px;
    padding-left: 9px;
    height: 22px;
    line-height: 22px;
    color: #fff;
    z-index: 2;
    background: url('../../assets/images/topleft.png');
    font-size: 11px;
  }
  .hyBtn {
    width: 110px;
    height: 36px;
    background: linear-gradient(90deg, #fdf8ef 0%, #f9dea2 100%);
    cursor: pointer;
    text-align: center;
    line-height: 36px;
    font-size: 14px;
    color: #957b5f;
    margin-top: 12px;
  }
}
.namms {
  display: flex;
  justify-content: center;
  padding: 30px;
  min-height: 750px;
  .btnBox {
    margin-top: 60px;
    display: flex;
    justify-content: center;
    .ordBtn {
      width: 180px;
      height: 48px;
      border-radius: 4px 4px 4px 4px;
      border: 1px solid #3172F6; 
      text-align: center;
      line-height: 48px;
      font-size: 16px;
      color: #3172F6; 
      margin-left: 60px;
      cursor: pointer;
    }
  }
  .suc {
    width: 1400px;
    height: 198px;
    border: 1px solid #ebebeb;
    box-shadow: 0 0 6px #ccc;
    margin-top: 22px;
    text-align: center;
    padding-top: 45px;
  }

  .payDetail {
    width: 1400px;
    margin-top: 16px;
    .payHead {
      padding: 0 45px;
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #666;
      height: 54px;
      border-top: 1px solid #d0d0d0;
      border-left: 1px solid #d0d0d0;
      border-right: 1px solid #d0d0d0;
      .su {
        width: 5px;
        height: 22px;
        border-radius: 4px;
        background: #4076f6;
        vertical-align: middle;
        margin-right: 5px;
      }
    }
    .list {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border: 1px dashed #d0d0d0;
      height: 40px;
      background: #f7f7f7;
      padding: 0 45px;
      font-size: 14px;
      color: #999999;
    }
    .tables {
      width: 100%;
      display: flex;
      justify-content: space-around;
      font-size: 16px;
      border: 1px solid #d0d0d0;
      border-top: 0;
      min-height: 60px;

      div {
        border-right: 1px solid #d0d0d0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 25%;
      }
      div:nth-child(5) {
        border: 0 !important;
      }
      .sudyBtn {
        width: 50% !important;
        height: 25px;
        color: #4076f6;
        border-radius: 3px;
        line-height: 25px;
        font-size: 14px;
        text-align: center;
        cursor: pointer;
        border: 0 !important;
      }
    }
  }
}
</style>
